<template>
    <div
        v-if="playlists.length"
        id="playlists"
    >
        <div style="overflow: hidden; height: 130px; position: absolute; top: -118px; left: 0px;z-index: 10">

            <img
                src="../../img/1.2.0/homeLeft.png"
                style="width: 190px; "
            >
        </div>
        <div style="overflow: hidden; height: 148px; position: absolute; top: -137px; right: 0px; z-index: 11">
            <img
                src="../../img/1.2.0/homeRight.png"
                style="width: 260px;  "
            >
        </div>
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1231.5px"
            height="75px"
            viewBox="0 0 2453 149"
            style="width: 1231.5px;position: relative; margin-top: -96px; margin-left: -126px; z-index: 200"
        >
            <g>
                <path
                    :fill="'#0A3020'"
                    d="M9.77.07S67.7,12.28,95.19,42.83s42.76,70.25,82.47,85.52,106.91,6.11,149.67,33.6,58,85.53,113,106.91,73.31-6.11,155.78,36.66S645.07,385,736.63,421.59c152,60.73,305.71-41.71,520.18-6.11V2041.7H0S23.17-13.33,9.77.07Z"
                />
                <path
                    :fill="'#0A3020'"
                    d="M506.114524,143.801238 C564.063532,146.205155 582.931801,112.692317 646.336694,93.0045385 C686.860476,80.4372241 674.426594,100.226433 819.561036,84.5451841 C858.740615,80.3155068 908.229048,93.0045385 928.846758,71.8460092 C949.464467,50.68748 982.46664,57.0370674 1003.08435,57.0370674 C1023.70206,57.0370674 1060.8258,37.9883052 1081.44351,35.868395 C1102.06122,33.7484848 1149.49381,10.5106178 1219.60984,2.01069091 C1289.72586,-6.489236 1333.02701,14.7098657 1333.02701,14.7098657 C1356.81644,40.3520486 1388.65493,60.1478527 1428.54249,74.0972782 C1482.60668,93.0045385 1590.90439,111.000488 1669.17291,122.708768 C1678.94529,124.170629 1855.48677,83.0930211 1921.35084,84.5451841 C1981.5991,85.8735301 2031.40338,29.8164373 2096.5642,35.868395 C2137.09188,39.6324943 2183.52777,74.8888282 2222.45437,84.5451841 C2267.60297,95.7450021 2346.64199,94.8288191 2381.94753,103.593946 C2445.28283,119.317885 2450.49515,141.351924 2454,143.801238 C2462.34004,149.62956 1542.85503,145.361207 1514.46994,146.367445 C1490.67818,147.210852 1430.52666,147.210852 1334.01539,146.367445 L106.589569,146.367445 C70.7592494,146.157979 47.0378702,146.157979 35.4254309,146.367445 C14.2351313,146.749677 1.14735601,150.280222 0.982527816,146.367445 C0.689522371,138.347268 35.0286798,115.623319 104,78.1955966 C104,78.1955966 114.308855,71.8460092 159.675723,59.1468344 C205.042591,46.4476596 266.905604,78.1955966 289.589038,93.0045385 C325.170895,116.222119 338.395486,92.771247 380.322774,103.593946 C403.172996,109.496342 425.308617,118.001754 446.317236,128.951723 C465.146351,137.764181 485.442512,142.804344 506.114524,143.801238 Z"
                />
            </g>
        </svg>

        <f7-block-title>Your sexy playlists
            <f7-link
                href="#"
                style="float: right; font-weight: bold; font-size: 15px; font-family: AndesLight; color: #EFC6AB; line-height: 30px"
                @click="submit"
            >Submit</f7-link>
        </f7-block-title>

        <f7-swiper
            :params="{slidesOffsetAfter: 16,slidesOffsetBefore: 16, speed:500, slidesPerView: 'auto', spaceBetween: 10, noSwiping: true}"
            :navigation="!isPgap"
        >
            <template v-for="(playlist, index) in playlists">
                <f7-swiper-slide
                    :key="`playlist-${index}`"
                    style="width: 120px"
                >
                    <div
                        :style="`background-image: url(${playlist.imageUrl})`"
                        class="playlist onHome"
                        @click="doPlay(playlist)"
                    >
                        <!-- <h3>
                            <span>
                                {{ playlist.name }}
                            </span>
                        </h3> -->
                    </div>
                </f7-swiper-slide>
            </template>
        </f7-swiper>
    </div>
</template>

<script>
// Note: Some of this code was taken from an old project of Eti's

export default {
    props: [],
    store: ['api', 'user'],
    data () {
        return {
            playlists: [
                {
                    id: 1,
                    name: 'Top 40 for business time',
                    imageUrl: 'https://data.getcoral.app/images/1.4.0/playlist_three.jpg',
                    providers: [{
                        name: 'Spotify',
                        url: 'https://open.spotify.com/playlist/0ceziz39fSU9njyiSyaVSo',
                    },
                    {
                        name: 'Apple Music',
                        url: 'https://music.apple.com/us/playlist/top-40-for-business-time/pl.u-8aAVZAaFv85zPRR',
                    }]
                },
                {
                    id: 2,
                    name: '\'90s slow jams for private lap dances',
                    imageUrl: 'https://data.getcoral.app/images/1.4.0/playlist_one.jpg',
                    providers: [{
                        name: 'Spotify',
                        url: 'https://open.spotify.com/playlist/2XUjdNzJWJO3EPGtq3Z3xA',
                    },
                    {
                        name: 'Apple Music',
                        url: 'https://music.apple.com/us/playlist/90s-slow-jams-for-private-lap-dances/pl.u-KVXBklLuL8Yr2MM',
                    }]
                },
                {
                    id: 3,
                    name: 'Shoegaze for a steamy striptease',
                    imageUrl: 'https://data.getcoral.app/images/1.4.0/playlist_two.jpg',
                    providers: [{
                        name: 'Spotify',
                        url: 'https://open.spotify.com/playlist/6POf1Sk2jPjelR8fkZ4aK4',
                    },
                    {
                        name: 'Apple Music',
                        url: 'https://music.apple.com/us/playlist/shoegaze-for-a-steamy-striptease/pl.u-oZylD6gsGzLWZEE',
                    }]
                },
                {
                    id: 4,
                    name: 'Rebellious rock to get down to',
                    imageUrl: 'https://data.getcoral.app/images/1.4.0/playlist_four.jpg',
                    providers: [{
                        name: 'Spotify',
                        url: 'https://open.spotify.com/playlist/33lVhZEvmIV9HUte6MJ6jf',
                    },
                    {
                        name: 'Apple Music',
                        url: 'https://music.apple.com/us/playlist/rebellious-rock-to-get-down-to/pl.u-kv9l2aJTJgEr9qq',
                    }]
                },
                {
                    id: 5,
                    name: 'Introspective ambient for deep connection',
                    imageUrl: 'https://data.getcoral.app/images/1.4.0/playlist_five.jpg',
                    providers: [{
                        name: 'Spotify',
                        url: 'https://open.spotify.com/playlist/2Zt61kfj97ciB6I5C86xkC',
                    },
                    {
                        name: 'Apple Music',
                        url: 'https://music.apple.com/us/playlist/introspective-ambient-for-deep-connection/pl.u-xlyNEpVtJY643RR',
                    }]
                },

            ],
            submission: {
                title: '',
                text: '',
                type: 'playlist'
            }
        };
    },
    computed: {
        isPgap: function () {
            return pgap;
        }
    },
    methods: {
        submit: function () {
            f7.dialog.prompt('Have a playlist for us? Send it in and we might feature it! Just paste the url to your playlist below.', (url) => {
                if (url.length < 10) return;
                this.submission.text = url;
                this.$http.post(`${this.api}/submissions`, this.submission).then(
                    () => {
                        this.$events.fire('trackEvent', `submit_${this.submission.type}`, 'submission', 0, '', {});
                        f7.dialog.alert('Thanks!');
                    },
                    response => {
                        f7.dialog.alert(response.body.message || 'Unknown error');
                    }
                );
            });
        },
        doPlay: function (playlist) {
            f7.dialog.create({
                title: 'Which music service would you like to use?',
                // text: 'Dialog with vertical buttons',
                buttons: [

                    {
                        text: playlist.providers[0].name,
                        onClick: () => {
                            this.$events.fire('trackEvent', `playlist_redirect`, 'playlist', playlist.id, playlist.name, {
                                provider: playlist.providers[0].name
                            });

                            window.open(playlist.providers[0].url, this.isPgap ? '_system' : '_blank');
                        }
                    },
                    {
                        text: playlist.providers[1].name,
                        onClick: () => {
                            this.$events.fire('trackEvent', `playlist_redirect`, 'playlist', playlist.id, playlist.name, {
                                provider: playlist.providers[1].name
                            });
                            window.open(playlist.providers[1].url, this.isPgap ? '_system' : '_blank');
                        }
                    },

                    {
                        text: 'Cancel',
                    },

                ],
                verticalButtons: true,
            }).open();
        }
    }
};
</script>

<style lang="less" scoped>
@import '../../css/colors.less';
.block-title {
    margin: 8px 16px;
    color: white;
    position: relative;
    z-index: 15;
    text-align: left;
    font-family: Editor-Bold;
    font-size: 21px;
    line-height: 26px;
}

#playlists {
    background: #0a3020;
    position: relative;
    z-index: 200;
    margin-top: -30px;
}
.playlist {
    cursor: pointer;
    margin-bottom: 10px;
    position: relative;
    overflow: hidden;
    // border-radius: 14px;
    width: 100%;
    min-width: 240px;
    max-width: 350px;
    display: inline-block;
    height: 90px;
    background-position: top center;
    background-size: cover;
    transition: all 0.3 ease;
    // backdrop-filter: blur(20px);
    // border: 2px solid white;
    h3 {
        text-align: left;
        margin-left: 30px;
        font-family: Editor-Bold;
        font-style: normal;
        font-size: 16px;
        line-height: 40px;
        letter-spacing: -0.1px;
        color: #fff;
        padding: 0px 3px 0;
        span {
            display: inline-block;
            vertical-align: middle;
            line-height: 18px;
        }
    }
    &.onHome {
        height: 120px;
        margin-right: 20px;
        min-width: 120px;
        max-width: 140px;
        h3 {
            text-align: center;
            margin-left: 0px;
            line-height: 80px;
        }
    }
}
</style>
